module.exports = __webpack_public_path__ + "img/bg-home-1.bab16035.png";